import { Card } from "react-bootstrap";
import { ACROSS_LOGO } from "../../assets";
import LoadingSpinner from "../../components/GlobalLoading";
import { useCertificateData } from "./certificateData";
import BackButton from "../../components/backButton";
import CertificateForm from "./components/CertificateForm";
import CertificateTable from "./components/CertificateTable";
import ErrorModal from "./components/ErrorModal";

import "./index.scss";

const Certificate = () => {
  const {
    handleSubmit,
    isUserMobile,
    setIsUserMobile,
    sendOtpApi,
    isUserOtp,
    setIsUserOtp,
    showResendOtpTimer,
    setShowResendOtpTimer,
    formatTime,
    reSendOtpApi,
    showNavigationRouter,
    certificateList,
    onViewCertificate,
    handleRefresh,
    showError,
    handleClose,
    errorMessage,
    loading,
    timeLeft,
    setTimeLeft,
    isOtpSent,
    isCertificateLoading,
  } = useCertificateData();

  return (
    <>
      <div className="certificate-page">
        <BackButton color="black" />

        <div className="certificate-page__content">
          <div className="certificate-page__logo-container">
            <img
              alt="Logo"
              src={ACROSS_LOGO}
              className="certificate-page__logo"
            />
          </div>

          <Card className="certificate-page__card">
            <Card.Body className="certificate-page__card_body">
              <p className="certificate-page__warning">
                *Ensure the mobile number matches at the time of purchase.
              </p>

              <CertificateForm
                handleSubmit={handleSubmit}
                isUserMobile={isUserMobile}
                setIsUserMobile={setIsUserMobile}
                sendOtpApi={sendOtpApi}
                isUserOtp={isUserOtp}
                setIsUserOtp={setIsUserOtp}
                showResendOtpTimer={showResendOtpTimer}
                setShowResendOtpTimer={setShowResendOtpTimer}
                formatTime={formatTime}
                reSendOtpApi={reSendOtpApi}
                showNavigationRouter={showNavigationRouter}
                handleRefresh={handleRefresh}
                timeLeft={timeLeft}
                setTimeLeft={setTimeLeft}
                isOtpSent={isOtpSent}
                loading={loading}
                isCertificateLoading={isCertificateLoading}
              />

              <CertificateTable
                certificateList={certificateList}
                onViewCertificate={onViewCertificate}
              />
            </Card.Body>
          </Card>
        </div>
      </div>

      <ErrorModal
        show={showError}
        onClose={handleClose}
        message={errorMessage}
      />

      <LoadingSpinner open={loading} />
    </>
  );
};

export default Certificate;
